<template>
  <!-- 订单状态信息 -->
  <div class="order_status_con text_left">
    <div class="font16 font_weight500 colo087 order_title">
      {{ orderStatus(getUserOrder.status).name }}
    </div>
    <div class="font12 font_weight400 colo087">
      {{ getUserOrder.retailSubOrderList[chooseIndex].statusConstant }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    chooseIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  methods: {
    orderStatus(status) {
      switch (status) {
        case 10:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "待付款"
          };
        case 11:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "待发货"
          };
        case 12:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "待收货"
          };
        case 13:
        case 14:
          return {
            img: require("@/assets/order/icon_time2x.png"),
            name: "已完成"
          };
        case -10:
        case -11:
          return {
            img: require("@/assets/order/icon_wait@2x.png"),
            name: "已关闭"
          };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.order_status_con {
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px 16px;
  .order_title {
    padding-bottom: 12px;
  }
}
</style>
